<div class="employee-certificates-manager">
    <nz-card>
        <div class="mb-4 flex items-center justify-between">
            <h3 class="m-0 text-lg font-semibold">Certificates</h3>
            <button
                nz-button
                nzType="primary"
                nzSize="large"
                (click)="addCertificate()"
                [disabled]="readonly || certificatesFormArray.length >= 20"
                class="flex items-center"
            >
                <mat-icon
                    class="mr-2"
                    style="
                        font-size: 18px;
                        width: 18px;
                        height: 18px;
                        vertical-align: middle;
                        color: white;
                    "
                    >add</mat-icon
                >
                <span>Add Certificate</span>
            </button>
        </div>

        <!-- Empty state -->
        <div
            *ngIf="certificatesFormArray.length === 0"
            class="py-12 text-center"
        >
            <mat-icon
                class="mb-3 text-6xl text-gray-300"
                style="width: 64px; height: 64px; font-size: 64px"
                >description</mat-icon
            >
            <p class="mb-4 text-gray-500">No certificates added</p>
            <p class="text-sm text-gray-400">
                Add certificates only if applicable
            </p>
        </div>

        <!-- Certificates list -->
        <div
            *ngIf="certificatesFormArray.length > 0"
            class="grid grid-cols-1 gap-4"
        >
            <div
                *ngFor="
                    let certForm of certificatesFormArray.controls;
                    let i = index
                "
                [formGroup]="getCertificateForm(i)"
                class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-shadow hover:shadow-md"
            >
                <div class="mb-4 flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <h4 class="m-0 text-base font-semibold text-gray-800">
                            Certificate #{{ i + 1 }}
                        </h4>
                        <!-- Badge for existing certificates -->
                        <span
                            *ngIf="isExistingCertificate(i)"
                            class="inline-flex items-center gap-1 rounded-md border border-blue-200 bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700"
                        >
                            <mat-icon
                                class="text-blue-600"
                                style="
                                    font-size: 16px;
                                    width: 16px;
                                    height: 16px;
                                "
                                >verified</mat-icon
                            >
                            <span>Existing Certificate</span>
                        </span>
                    </div>
                    <button
                        mat-icon-button
                        (click)="removeCertificate(i)"
                        [disabled]="readonly"
                        matTooltip="Remove certificate"
                        class="text-gray-400 hover:text-red-500"
                    >
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>

                <div class="space-y-4">
                    <!-- Certificate Type Dropdown -->
                    <div class="w-full">
                        <label
                            class="mb-2 block text-sm font-semibold text-gray-700"
                        >
                            Type of Certificate
                            <span class="text-red-500">*</span>
                        </label>
                        <nz-select
                            formControlName="certificate_type_id"
                            nzShowSearch
                            nzAllowClear
                            nzSize="large"
                            nzPlaceHolder="Search certificate type"
                            class="w-full"
                            [nzDisabled]="readonly"
                            (ngModelChange)="onCertificateTypeChange(i)"
                        >
                            <nz-option
                                *ngFor="let cert of certificateTypes$ | async"
                                [nzValue]="cert.id"
                                [nzLabel]="cert.cert_name"
                            >
                            </nz-option>
                        </nz-select>
                        <div
                            *ngIf="
                                getCertificateForm(i).get('certificate_type_id')
                                    ?.invalid &&
                                getCertificateForm(i).get('certificate_type_id')
                                    ?.touched
                            "
                            class="mt-1 text-xs text-red-500"
                        >
                            Certificate type is required
                        </div>
                    </div>

                    <!-- File Upload or View Existing Certificate -->
                    <div class="w-full">
                        <label
                            class="mb-2 block text-sm font-semibold text-gray-700"
                        >
                            Certificate Document
                            <span
                                class="text-red-500"
                                *ngIf="!isExistingCertificate(i)"
                                >*</span
                            >
                        </label>

                        <!-- Existing Certificate - View Only -->
                        <div
                            *ngIf="isExistingCertificate(i)"
                            class="rounded-lg border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50 p-5 shadow-sm"
                        >
                            <div class="mb-3 flex items-center justify-between">
                                <div class="flex items-center gap-3">
                                    <div class="rounded-lg bg-blue-100 p-2">
                                        <mat-icon
                                            class="text-blue-600"
                                            style="
                                                font-size: 24px;
                                                width: 24px;
                                                height: 24px;
                                            "
                                            >description</mat-icon
                                        >
                                    </div>
                                    <div>
                                        <p
                                            class="mb-0.5 text-sm font-semibold text-gray-900"
                                        >
                                            Existing Certificate File
                                        </p>
                                        <p class="text-xs text-gray-600">
                                            Previously uploaded and saved
                                        </p>
                                    </div>
                                </div>
                                <a
                                    [href]="
                                        getCertificateForm(i).get(
                                            'certificate_url'
                                        )?.value
                                    "
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    mat-raised-button
                                    color="primary"
                                    class="flex items-center gap-1.5"
                                >
                                    <mat-icon
                                        style="
                                            font-size: 20px;
                                            width: 20px;
                                            height: 20px;
                                        "
                                        >open_in_new</mat-icon
                                    >
                                    <span>View Certificate</span>
                                </a>
                            </div>
                            <div
                                class="flex items-center gap-2 rounded-md border border-blue-100 bg-white bg-opacity-60 px-3 py-2"
                            >
                                <mat-icon
                                    class="flex-shrink-0 text-blue-600"
                                    style="
                                        font-size: 18px;
                                        width: 18px;
                                        height: 18px;
                                    "
                                    >info_outline</mat-icon
                                >
                                <p class="m-0 text-xs text-gray-700">
                                    To replace this certificate, remove it and
                                    add a new one
                                </p>
                            </div>
                        </div>

                        <!-- New Certificate - File Upload -->
                        <div *ngIf="!isExistingCertificate(i)">
                            <!-- Hidden file input -->
                            <input
                                type="file"
                                #fileInput
                                (change)="handleFileSelect($event, i)"
                                accept=".pdf,image/jpeg,image/jpg,image/png"
                                [disabled]="readonly"
                                hidden
                            />

                            <!-- Upload button -->
                            <button
                                type="button"
                                mat-stroked-button
                                (click)="fileInput.click()"
                                [disabled]="readonly"
                                class="flex h-10 w-full items-center justify-center"
                            >
                                <mat-icon class="mr-2" style="font-size: 20px"
                                    >upload_file</mat-icon
                                >
                                {{
                                    getCertificateForm(i).get('filename')?.value
                                        ? 'Change File'
                                        : 'Select File'
                                }}
                            </button>

                            <!-- Selected file display -->
                            <div
                                *ngIf="
                                    getCertificateForm(i).get('filename')?.value
                                "
                                class="mt-2 flex items-center justify-between rounded border border-gray-200 bg-gray-50 p-2"
                            >
                                <div class="flex min-w-0 flex-1 items-center">
                                    <mat-icon
                                        class="mr-2 flex-shrink-0 text-gray-600"
                                    >
                                        {{
                                            getCertificateForm(i)
                                                .get('filename')
                                                ?.value?.endsWith('.pdf')
                                                ? 'picture_as_pdf'
                                                : 'image'
                                        }}
                                    </mat-icon>
                                    <span
                                        class="truncate text-sm text-gray-700"
                                    >
                                        {{
                                            getCertificateForm(i).get(
                                                'filename'
                                            )?.value
                                        }}
                                    </span>
                                </div>
                                <button
                                    *ngIf="!readonly"
                                    mat-icon-button
                                    color="warn"
                                    (click)="removeFile(i)"
                                    type="button"
                                    matTooltip="Remove file"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>

                            <div
                                *ngIf="
                                    getCertificateForm(i).get('file')
                                        ?.invalid &&
                                    getCertificateForm(i).get('file')?.touched
                                "
                                class="mt-1 text-xs text-red-500"
                            >
                                Certificate file is required
                            </div>
                            <p class="mt-1 text-xs text-gray-500">
                                <mat-icon
                                    class="align-middle mr-1 text-xs"
                                    style="
                                        font-size: 12px;
                                        width: 12px;
                                        height: 12px;
                                    "
                                    >info</mat-icon
                                >
                                Max 5MB. Accepted: PDF, JPEG, JPG, PNG
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Expiry Configuration -->
                <div class="mt-4 space-y-4">
                    <div class="w-full">
                        <label class="flex items-center">
                            <nz-switch
                                formControlName="has_expiry"
                                (ngModelChange)="
                                    onExpiryToggleChange($event, i)
                                "
                                [nzDisabled]="readonly"
                            >
                            </nz-switch>
                            <span class="ml-2 text-sm font-medium text-gray-700"
                                >Does this certificate expire?</span
                            >
                        </label>
                    </div>

                    <div
                        class="w-full"
                        *ngIf="getCertificateForm(i).get('has_expiry')?.value"
                    >
                        <label
                            class="mb-2 block text-sm font-semibold text-gray-700"
                        >
                            When does it expire?
                            <span class="text-red-500">*</span>
                        </label>
                        <nz-date-picker
                            formControlName="expiry_date"
                            [nzDisabledDate]="disablePastDates"
                            nzFormat="dd/MM/yyyy"
                            nzSize="large"
                            nzPlaceHolder="Select expiry date"
                            class="w-full"
                            [nzDisabled]="readonly"
                            (ngModelChange)="onExpiryDateChange($event, i)"
                        >
                        </nz-date-picker>
                        <div
                            *ngIf="
                                getCertificateForm(i).get('expiry_date')
                                    ?.invalid &&
                                getCertificateForm(i).get('expiry_date')
                                    ?.touched &&
                                getCertificateForm(i).get('has_expiry')?.value
                            "
                            class="mt-1 text-xs text-red-500"
                        >
                            Expiry date is required
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Max certificates warning -->
        <div
            *ngIf="certificatesFormArray.length >= 20"
            class="mt-4 flex items-center text-sm text-orange-500"
        >
            <mat-icon class="mr-1">warning</mat-icon>
            Maximum limit of 20 certificates reached
        </div>
    </nz-card>
</div>
